<script>
  import { CONSTS, createReadableGalleryTitle, fetchGallery, getGalleryTitle } from './utils'
  import { EffectFade, Lazy, Controller } from 'swiper'
  import { Swiper, SwiperSlide } from 'swiper/svelte'
  import { getSizedImageUrl } from '@shopify/theme-images'
  import ProductCard from './ProductCard.svelte'
  import Spinner from './Spinner.svelte'
  import 'swiper/css'
  import 'swiper/css/effect-fade'
  import { listen } from 'svelte/internal'

  export let galleryInfo
  export let galleryId
  export let onGalleryClose = () => {}
  export let config
  let onEvent = config.onEvent || (() => {})

  let galleryClass = config.gallery.cssClass || ''
  let thumbClass = config.gallery.thumbCssClass || ''
  let goBackClass = config.gallery.goBackCssClass || ''

  const LOOP = true
  let selectedIndex = 0
  let gallery = null
  let productHandles = new Set()

  $: galleryTitle = createReadableGalleryTitle(
    getGalleryTitle(galleryInfo) || getGalleryTitle(gallery),
  )

  function getDesc(desc) {
    if (typeof desc === 'string') {
      if (desc === '<p><br></p>') return undefined
      return desc
    }
  }

  $: galleryDescription = getDesc(gallery?.description?.en)

  let galleryPromise = fetchGallery(config.shopHandle, galleryId, config).then(gal => {
    gal.images?.forEach(imgItem => {
      if (!imgItem.msrc || !imgItem.src) {
        imgItem.src = imgItem.url
        imgItem.msrc = getSizedImageUrl(imgItem.src, 'x350') || imgItem.src
      }

      imgItem.products?.forEach(prodItem => {
        productHandles.add(prodItem.handle)
      })
    })
    productHandles = Array.from(productHandles)

    if (__DEV__) {
      gal.images = [...gal.images, ...gal.images]
    }

    onEvent(CONSTS.EVENT.GALLERY_FETCHED, { galleryId, response: gal })
    gallery = gal

    return gal
  })

  $: {
    galleryPromise
    onEvent(CONSTS.EVENT.GALLERY_LOADING, {
      galleryId,
    })
  }

  // store Controller swiper instance
  let swiperInstance = null

  /** @type HTMLElement | null */
  let galRoot
</script>

{#await galleryPromise}
  <div class="XOC_Centered-spinner">
    <Spinner />
  </div>
{:then gal}
  <div class={`XOC_Gal ${galleryClass}`} bind:this={galRoot}>
    <slot name="header" {galleryTitle} {galleryDescription} />
    <div class={`XOC_Gal--Grid`}>
      <div class="XOC_Gal--main-img">
        <Swiper
          modules={[Controller, EffectFade, Lazy]}
          effect="fade"
          fadeEffect={{
            crossFade: true,
          }}
          autoHeight={true}
          preloadImages={false}
          lazy={{
            loadPrevNextAmount: 2,
          }}
          loop={LOOP}
          slidesPerView={1}
          initialSlide={selectedIndex}
          on:swiper={e => {
            ;[swiperInstance] = e.detail
          }}
          on:slideChange={async () => {
            if (swiperInstance) {
              let prevIndex = selectedIndex
              selectedIndex = swiperInstance?.realIndex
              // if (galRoot) {
              //   await tick()
              //   let activeThumb = galRoot.querySelector('.XOC_Gal--thumb.activeThumb')
              //   if (activeThumb) {
              //     activeThumb.scrollIntoView({ block: 'end', inline: 'nearest' })
              //   }
              // }
              onEvent(CONSTS.EVENT.GALLERY_IMG_CHANGED, {
                fromIndex: prevIndex,
                toIndex: selectedIndex,
              })
            }
          }}
        >
          {#each gal.images as imgItem, idx (idx + imgItem.src)}
            <SwiperSlide class="XOC-c-cell">
              <img
                class="swiper-lazy"
                width={imgItem.w}
                height={imgItem.h}
                src={imgItem.msrc}
                data-src={imgItem.src}
                alt=""
              />
              <div class="swiper-lazy-preloader" />
            </SwiperSlide>
          {/each}
        </Swiper>
        <span class="XOC_Swiper--counter">{selectedIndex + 1}/{gal.images.length}</span>
      </div>

      <div class="XOC_Gal--panel">
        {#each gal.images as image, idx}
          <div class={`XOC_Gal--thumb ${thumbClass}`} class:activeThumb={selectedIndex === idx}>
            <a
              href={image.src}
              target="_blank"
              on:click|preventDefault={() => {
                LOOP ? swiperInstance.slideToLoop(idx) : swiperInstance.slideTo(idx)
              }}
            >
              <img class="block lazyloaded" src={image.msrc} alt="" />
            </a>
          </div>
        {/each}
      </div>
    </div>
  </div>

  {#if Array.isArray(productHandles) && productHandles.length > 0}
  <div class="XOC_Gal--products">
    <h2>Products</h2>
    <div class="grid grid--uniform">
      {#each productHandles as productHandle}
        <ProductCard handle={productHandle} {config} title={galleryTitle} />
      {/each}
    </div>
  </div>
  {/if}
{:catch error}
  <slot name="error">
    <p style="color: red">
      {error.message}
    </p>
    <button class={goBackClass} on:click={onGalleryClose}>Go back</button>
  </slot>
{/await}
